import { API_AMOCRM } from "./api";

export const getContacts = () => {
    return API_AMOCRM.get('contacts');
}

export const contactsQuery = (query) => {
    return API_AMOCRM.get(`amo/contacts?query=${query}`);
}